import { PromoCode } from '../../../lib/types/models/promo-code/promo-code'
import { PromoCodeInput } from '../../../lib/types/models/promo-code/promo-code-input'

export const mapPromoCodeIntoInput = (promoCode: PromoCode): PromoCodeInput => {
  return {
    code: promoCode.code,
    discount: promoCode.discount,
    name: promoCode.name,
    type: promoCode.type,
    validFrom: promoCode.validFrom,
    validUntil: promoCode.validUntil,
    includedInsurance: promoCode.includedInsurance,
    application: promoCode.application,
    journeys: promoCode.journeys.map((journey) => journey.id),
    productJourneyPlaces: promoCode.productJourneyPlaces.map((journeyPlace) => journeyPlace.id)
  }
}
